<template>
  <el-dialog
    title="手术量编辑"
    :visible.sync="isShowSurgeryAppointment"
    :close-on-click-modal="false"
    :show-close="false"
    width="1800px"
    class="reserve-operation-wrapper"
  >
    <div class="content-wrap">
      <div class="title-box">
        <div class="text-item">时间</div>
        <div class="text-item">星期一上午</div>
        <div class="text-item">星期一下午</div>
        <div class="text-item">星期二上午</div>
        <div class="text-item">星期二下午</div>
        <div class="text-item">星期三上午</div>
        <div class="text-item">星期三下午</div>
        <div class="text-item">星期四上午</div>
        <div class="text-item">星期四下午</div>
        <div class="text-item">星期五上午</div>
        <div class="text-item">星期五下午</div>
        <div class="text-item">星期六上午</div>
        <div class="text-item">星期六下午</div>
        <div class="text-item">星期日上午</div>
        <div class="text-item">星期日下午</div>
      </div>
      <div class="input-wrap">
        <div class="input-item">手术数量</div>
        <div class="input-item" v-for="(value, key) in formData">
          <input
            class="input"
            type="text"
            placeholder=""
            maxlength="2"
            v-model="formData[key]"
            @input="formData[key] = formData[key].replace(/[^\d]/g, '')"
          >
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="confirm" style="margin-left: 20px">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  
  export default {
    
    props: {
      isShowSurgeryAppointment: Boolean,
    },
    
    data() {
      //leaderId的命名存在歧义，起作用是临时存储手术数量表的id字段；teamId的作用是存储leader_id；by zdh
      return {
        dialogVisible: true,
        formData: {
          monday_am: '', 
          monday_pm: '', 
          tuesday_am: '', 
          tuesday_pm: '', 
          wednesday_am: '', 
          wednesday_pm: '', 
          thursday_am: '', 
          thursday_pm: '', 
          friday_am: '', 
          friday_pm: '', 
          saturday_am: '', 
          saturday_pm: '', 
          sunday_am: '', 
          sunday_pm: ''
        },
        
        configId: -1,
        leaderId: -1,
      };
    },
    
    methods: {
      cancel() {
        this.$emit('closeSurgeryAppointment');
      },
      async confirm() {
        if (this.configId === -1) {
          await this.addOperationConfigNew();
        } else {
          await this.modifyOperationConfigNew();
        }
        this.$message({
          message: '保存成功',
          type: 'success',
        });
        this.$emit('closeSurgeryAppointment');
        this.getOperationLeft();
        
      },
      async addOperationConfigNew() {
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation(
              $team_id: Int!
              $monday_am: Int!
              $monday_pm: Int!
              $tuesday_am: Int!
              $tuesday_pm: Int!
              $wednesday_am: Int!
              $wednesday_pm: Int!
              $thursday_am: Int!
              $thursday_pm: Int!
              $friday_am: Int!
              $friday_pm: Int!
              $saturday_am: Int!
              $saturday_pm: Int!
              $sunday_am: Int!
              $sunday_pm: Int!
            ){
            addOperationConfigNew(
              team_id: $team_id,
              monday_am: $monday_am,
              monday_pm: $monday_pm,
              tuesday_am: $tuesday_am,
              tuesday_pm: $tuesday_pm,
              wednesday_am: $wednesday_am,
              wednesday_pm: $wednesday_pm,
              thursday_am: $thursday_am,
              thursday_pm: $thursday_pm,
              friday_am: $friday_am,
              friday_pm: $friday_pm,
              saturday_am: $saturday_am,
              saturday_pm: $saturday_pm,
              sunday_am: $sunday_am,
              sunday_pm: $sunday_pm
            ){
              id
            }
          }`,
            variables: {
              team_id: this.leaderId,
              monday_am: this.formData.monday_am ? Number(this.formData.monday_am) : 0,
              monday_pm: this.formData.monday_pm ? Number(this.formData.monday_pm) : 0,

              tuesday_am: this.formData.tuesday_am ? Number(this.formData.tuesday_am) : 0,
              tuesday_pm: this.formData.tuesday_pm ? Number(this.formData.tuesday_pm) : 0,

              wednesday_am: this.formData.wednesday_am ? Number(this.formData.wednesday_am) : 0,
              wednesday_pm: this.formData.wednesday_pm ? Number(this.formData.wednesday_pm) : 0,

              thursday_am: this.formData.thursday_am ? Number(this.formData.thursday_am) : 0,
              thursday_pm: this.formData.thursday_pm ? Number(this.formData.thursday_pm) : 0,

              friday_am: this.formData.friday_am ? Number(this.formData.friday_am) : 0,
              friday_pm: this.formData.friday_pm ? Number(this.formData.friday_pm) : 0,

              saturday_am: this.formData.saturday_am ? Number(this.formData.saturday_am) : 0,
              saturday_pm: this.formData.saturday_pm ? Number(this.formData.saturday_pm) : 0,

              sunday_am: this.formData.sunday_am ? Number(this.formData.sunday_am) : 0,
              sunday_pm: this.formData.sunday_pm ? Number(this.formData.sunday_pm) : 0
            },
          });
        } catch (error) {
          this.$message.error(error.message.split(':')[1]);
        }
      },
      async modifyOperationConfigNew() {
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation(
            $id: Int!
            $monday_am: Int
            $monday_pm: Int
            $tuesday_am: Int
            $tuesday_pm: Int
            $wednesday_am: Int
            $wednesday_pm: Int
            $thursday_am: Int
            $thursday_pm: Int
            $friday_am: Int
            $friday_pm: Int
            $saturday_am: Int
            $saturday_pm: Int
            $sunday_am: Int
            $sunday_pm: Int
          ) {
            modifyOperationConfigNew(
              id: $id
              monday_am: $monday_am,
              monday_pm: $monday_pm,
              tuesday_am: $tuesday_am,
              tuesday_pm: $tuesday_pm,
              wednesday_am: $wednesday_am,
              wednesday_pm: $wednesday_pm,
              thursday_am: $thursday_am,
              thursday_pm: $thursday_pm,
              friday_am: $friday_am,
              friday_pm: $friday_pm,
              saturday_am: $saturday_am,
              saturday_pm: $saturday_pm,
              sunday_am: $sunday_am,
              sunday_pm: $sunday_pm
)
          }`,
            variables: {
              id: this.configId,
              monday_am: this.formData.monday_am ? Number(this.formData.monday_am) : 0,
              monday_pm: this.formData.monday_pm ? Number(this.formData.monday_pm) : 0,

              tuesday_am: this.formData.tuesday_am ? Number(this.formData.tuesday_am) : 0,
              tuesday_pm: this.formData.tuesday_pm ? Number(this.formData.tuesday_pm) : 0,

              wednesday_am: this.formData.wednesday_am ? Number(this.formData.wednesday_am) : 0,
              wednesday_pm: this.formData.wednesday_pm ? Number(this.formData.wednesday_pm) : 0,

              thursday_am: this.formData.thursday_am ? Number(this.formData.thursday_am) : 0,
              thursday_pm: this.formData.thursday_pm ? Number(this.formData.thursday_pm) : 0,

              friday_am: this.formData.friday_am ? Number(this.formData.friday_am) : 0,
              friday_pm: this.formData.friday_pm ? Number(this.formData.friday_pm) : 0,

              saturday_am: this.formData.saturday_am ? Number(this.formData.saturday_am) : 0,
              saturday_pm: this.formData.saturday_pm ? Number(this.formData.saturday_pm) : 0,

              sunday_am: this.formData.sunday_am ? Number(this.formData.sunday_am) : 0,
              sunday_pm: this.formData.sunday_pm ? Number(this.formData.sunday_pm) : 0
            },
          });
        } catch (error) {
          this.$message.error(error.message.split(':')[1]);
        }
      },
      // 查询团队手术预约设置情况
      async getOperationLeft() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              me{
                id
                leader_id
              }
            }`,
            fetchPolicy: "no-cache",
          });
          this.leaderId = res.data.me.leader_id;
          const res1 = await this.$apollo.query({
            query: gql`{
              getOperationLeft(leaderid: ${res.data.me.leader_id}){
                id
                monday_am, 
                monday_pm, 
                tuesday_am, 
                tuesday_pm, 
                wednesday_am, 
                wednesday_pm, 
                thursday_am, 
                thursday_pm, 
                friday_am, 
                friday_pm, 
                saturday_am, 
                saturday_pm, 
                sunday_am, 
                sunday_pm
              }
            }`,
            fetchPolicy: "no-cache",
          });
          if (res1.data.getOperationLeft) {
            const resData = res1.data.getOperationLeft;
            this.formData = {
              monday_am: String(resData.monday_am),
              monday_pm: String(resData.monday_pm),
              tuesday_am: String(resData.tuesday_am),
              tuesday_pm: String(resData.tuesday_pm),
              wednesday_am: String(resData.wednesday_am),
              wednesday_pm: String(resData.wednesday_pm),
              thursday_am: String(resData.thursday_am),
              thursday_pm: String(resData.thursday_pm),
              friday_am: String(resData.friday_am),
              friday_pm: String(resData.friday_pm),
              saturday_am: String(resData.saturday_am),
              saturday_pm: String(resData.saturday_pm),
              sunday_am: String(resData.sunday_am),
              sunday_pm: String(resData.sunday_pm)
            };
            this.configId = resData.id;
          } else {
            this.formData = {
              monday_am: '0',
              monday_pm: '0',
              tuesday_am: '0',
              tuesday_pm: '0',
              wednesday_am: '0',
              wednesday_pm: '0',
              thursday_am: '0',
              thursday_pm: '0',
              friday_am: '0',
              friday_pm: '0',
              saturday_am: '0',
              saturday_pm: '0',
              sunday_am: '0',
              sunday_pm: '0'
            };
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      }
    },
    
    mounted() {
      this.getOperationLeft();
    },
  }
</script>

<style>
  /*dialog样式修改*/
  .reserve-operation-wrapper .el-dialog__header .el-dialog__title{
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .reserve-operation-wrapper .el-dialog__header{
    padding: 20px 24px 10px;
  }
  .reserve-operation-wrapper .el-dialog__body {
    padding: 0 20px;
  }
  .reserve-operation-wrapper .el-dialog__close{
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
</style>
<style lang="less" scoped>
  .reserve-operation-wrapper{
    input{
      padding: 0;
      border: 0;
    }
  }
  .reserve-operation-wrapper{
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    min-width: 1600px;
    
    .content-wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-top: 2px solid #4da3c0;
      padding: 50px 0;
      .title-box{
        display: flex;
        .text-item{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 70px;
          box-sizing: border-box;
          background-color: #d5d5d5;
          border-bottom: 1px solid #ababab;
        }
        .text-item + .text-item{
          border-left: 1px solid #ababab;
        }
        .text-item:nth-of-type(1){
          width: 100px;
        }
      }
      .input-wrap{
        display: flex;
        align-items: flex-end;
        .input-item{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 70px;
          box-sizing: border-box;
          background-color: #d5d5d5;
          .input{
            width: 100%;
            height: 100%;
            text-align: center;
            outline: none;
          }
        }
        .input-item:nth-of-type(1){
          width: 100px;
        }
        .input-item + .input-item{
          background-color: #ffffff;
          border-left: 1px solid #ababab;
          border-bottom: 1px solid #dadada;
        }
        .input-item:nth-child(8){
          border-right: 1px solid #dadada;
        }
        .confirm-btn{
          width: 110px;
          height: 40px;
          background-color: #4da3c0;
          border-radius: 10px;
          color: #fff;
          margin-left: 82px;
          cursor: pointer;
          user-select: none;
          text-align: center;
          line-height: 40px;
          font-size: 15px;
          letter-spacing: 5px;
        }
      }
    }
    .content-list-wrap{
      height: calc(100% - 220px);
      padding-top: 20px;
      box-sizing: border-box;
    }
    .dialog-footer{
      padding-right: 17px;
    }
  }
</style>
